module.exports = __webpack_public_path__ + "img/5.317ca951.png";